import React, { useEffect, useState } from "react";
import "./Mobile.css";
import Lottie from "lottie-react";
import techAnimation from "../assests/MobileAppAnimation.json";
import feature from "../images/Feature Priortization.png";
import mobile from "../images/MobileFocused.png";
import project from "../images/Project examination.png";
import qa from "../images/QA Testing.png";
import qualified from "../images/QualifiedDevelopment.png";
import release from "../images/Release and Maintenance.png";
export default function Mobile() {

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div id="Mobile" className="Mobile wf-section">
          <div className="techHero1">
        <div className="topCurve"></div>
        <div className="techCardFull">
          <div className={`logo_curve1 ${isScrolled ? "logo_curve1_scrolled" : ""}`}></div>
          <div className={`logo_curve2 ${isScrolled ? "logo_curve2_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve1 ${isScrolled ? "menu-icon-curve1_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve2 ${isScrolled ? "menu-icon-curve2_scrolled" : ""}`}></div>
          <div className="logo_curve1_Mo"></div>
          <div className="logo_curve2_Mo"></div>
          <div className="menu-icon-curve1_MV"></div>
          <div className="menu-icon-curve2_MV"></div>
          <div className="techContent1_M">
            <h1 className="tech-title1_M">MOBILE<br/><span>APP</span><br/>DEVELOPMENT</h1>
          </div>
          <div className="tech-animation1">
            <Lottie animationData={techAnimation} loop={true} speed={0.1} />
          </div>
        </div>
      </div>
          <div className="mobileAppSection">

  <h1 className="mainHeading">
    WHAT DO WE MEAN BY MOBILE <br /> APP DEVELOPMENT?
  </h1>

  <div className="gridContainer">
    <div className="card">
      <img src={project} alt="project" />
      <div>
        <h3>Project examination</h3>
        <p>
          True experts will never get to code right from the beginning — any app needs a coherent outline on how to move forward. In order to set objectives for the project management roadmap, we gather and analyze project requirements. This helps us get a clear understanding of future work and consider all potential goings-on.
        </p>
      </div>
    </div>
    <div className="card">
      <img src={feature} alt="feature" />
      <div>
        <h3>Feature prioritization</h3>
        <p>
          By putting aside all non-functional extras, we help a client get a better vision of a future product. Our managers use the MoSCoW method and plan a vital set of features. Thus, dispose of features users are not interested in and reduce the cost.
        </p>
      </div>
    </div>
    <div className="card">
      <img src={mobile} alt="mobile" />
      <div>
        <h3>Mobile-focused UI/UX design</h3>
        <p>
          We create wireframes and build low and high-fidelity prototypes screen by screen. If the client wants to get a universal interface, we’ll deal with it, if the client wants to have two custom versions for iOS and Android ,it’s always possible to implement the specific elements of each operating system.
        </p>
      </div>
    </div>
    <div className="card">
      <img src={qualified} alt="qualified" />
      <div>
        <h3>Qualified development</h3>
        <p>
          According to Scrum, we split the development process into sprints — it allows us to present intermediate builds to a client, therefore keep them in the loop. We use TestFlight and Google Play beta releases, which makes it possible to test a product on real devices.
        </p>
      </div>
    </div>
    <div className="card">
      <img src={qa} alt="qa" />
      <div>
        <h3>QA testing</h3>
        <p>
          We use quality control and management system to deliver high-quality products. Combining manual testing and automated testing technologies (RSpec, Capybara), we cover a wide range of conditions and scenarios, so a client could be sure a product won’t have any flyings out of control.
        </p>
      </div>
    </div>
    <div className="card">
      <img src={release} alt="release" />
      <div>
        <h3>Release and Maintenance</h3>
        <p>
          We ensure mobile apps that we work on are accepted and published in the App Store and Google Play. To make sure all bugs are fixed and the product steadily works, we provide post-launch support and further scale-up if needed.
        </p>
      </div>
    </div>

  </div>
</div>
    </div>
  );
}
